import { Button, Col, Dropdown, DropdownButton, Modal, Row } from "react-bootstrap";
import {
  EStatusEnvioMDFe,
  getDescricaoStatusEnvioMDFe,
  MDFeOutput,
} from "../MDFe.Dto";

interface Props {
  show: boolean;
  mdfe: MDFeOutput | undefined;
  onReturn: () => void;
  onDelete: (value: MDFeOutput) => void;
  onDownloadXml: (value: MDFeOutput) => void;
  onFetchStatus: (value: MDFeOutput) => void;
  onSend: (value: MDFeOutput) => void;
  onEdit: (value: MDFeOutput) => void;
  onDuplicate: (value: MDFeOutput) => void;
  onPrint?: (value: MDFeOutput) => void;
  onDownloadDamdfe?: (value: MDFeOutput) => void;
  onShareDamdfe?: (value: MDFeOutput) => void;
  onEvent?: (value: MDFeOutput) => void;
  onEncerrar?: (value: MDFeOutput) => void;
  onVisualizar?: (value: MDFeOutput) => void;
}

const MDFeModalPropriedadesView = (props: Props) => {
  const codigoStatusEnvio =
    props.mdfe?.autorizacao?.codigoStatusEnvio ??
    (props.mdfe as any)?.codigoStatusEnvio ??
    EStatusEnvioMDFe.Pendente;

  const descricaoStatusEnvio = getDescricaoStatusEnvioMDFe(
    codigoStatusEnvio,
    props.mdfe?.autorizacao?.descricaoStatusEnvio ??
      (props.mdfe as any)?.descricaoStatusEnvio
  );

  const totalCTe =
    props.mdfe?.quantidadeCTe !== undefined &&
    props.mdfe?.quantidadeCTe !== null &&
    Number(props.mdfe.quantidadeCTe) > 0
      ? Number(props.mdfe.quantidadeCTe)
      : (props.mdfe?.municipiosDescarga?.reduce(
          (acc, m) =>
            acc +
            (m.documentos?.filter((d) => Number(d.tipoDocumento) === 1).length ||
              0),
          0
        ) ?? 0);

  const totalNFe =
    props.mdfe?.quantidadeNFe !== undefined &&
    props.mdfe?.quantidadeNFe !== null &&
    Number(props.mdfe.quantidadeNFe) > 0
      ? Number(props.mdfe.quantidadeNFe)
      : (props.mdfe?.municipiosDescarga?.reduce(
          (acc, m) =>
            acc +
            (m.documentos?.filter((d) => Number(d.tipoDocumento) === 2).length ||
              0),
          0
        ) ?? 0);

  const docsVinculadosTexto = (() => {
    const partes: string[] = [];
    if (totalCTe > 0) partes.push(`${totalCTe} CT-e(s)`);
    if (totalNFe > 0) partes.push(`${totalNFe} NF-e(s)`);
    return partes.length > 0 ? partes.join(" | ") : "Nenhum documento";
  })();

  const valorCargaFormatado =
    props.mdfe?.valorTotalCarga !== undefined &&
    props.mdfe?.valorTotalCarga !== null &&
    !isNaN(Number(props.mdfe.valorTotalCarga))
      ? Number(props.mdfe.valorTotalCarga).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0,00";

  const isCancelado = codigoStatusEnvio === EStatusEnvioMDFe.Cancelado;
  const isEncerrado = codigoStatusEnvio === EStatusEnvioMDFe.Encerrado;
  const isCanceladoOuEncerrado = isCancelado || isEncerrado;

  const isAutorizado =
    !isCanceladoOuEncerrado &&
    (codigoStatusEnvio === EStatusEnvioMDFe.Autorizado ||
      props.mdfe?.autorizacao?.codigoStatusResposta === 100);

  const onDeleteHandler = () => {
    if (props.mdfe) {
      props.onReturn();
      props.onDelete(props.mdfe);
    }
  };

  const onDownloadXmlHandler = () => {
    if (props.mdfe) {
      props.onDownloadXml(props.mdfe);
    }
  };

  const onDuplicateHandler = () => {
    if (props.mdfe) {
      props.onDuplicate(props.mdfe);
    }
  };

  const onFetchStatusHandler = () => {
    if (props.mdfe) {
      props.onFetchStatus(props.mdfe);
    }
  };

  const onReturnHandler = () => {
    props.onReturn();
  };

  const onSendHandler = () => {
    if (props.mdfe) {
      props.onSend(props.mdfe);
    }
  };

  const onEditHandler = () => {
    if (props.mdfe) {
      props.onEdit(props.mdfe);
    }
  };

  const onPrintHandler = () => {
    if (props.mdfe && props.onPrint) {
      props.onPrint(props.mdfe);
    }
  };

  const onDownloadDamdfeHandler = () => {
    if (props.mdfe && props.onDownloadDamdfe) {
      props.onDownloadDamdfe(props.mdfe);
    }
  };

  const onShareDamdfeHandler = () => {
    if (props.mdfe && props.onShareDamdfe) {
      props.onShareDamdfe(props.mdfe);
    }
  };

  const onEventHandler = () => {
    if (props.mdfe && props.onEvent) {
      props.onEvent(props.mdfe);
    }
  };

  const onEncerrarHandler = () => {
    if (props.mdfe && props.onEncerrar) {
      props.onEncerrar(props.mdfe);
    }
  };

  const onVisualizarHandler = () => {
    if (props.mdfe) {
      if (props.onVisualizar) {
        props.onVisualizar(props.mdfe);
      } else if (props.mdfe.id) {
        window.open(`/fiscal/mdfe/${props.mdfe.id}/visualizar`, "_blank");
      }
    }
  };

  return (
    <Modal show={props.show} centered onHide={props.onReturn}>
      <Modal.Header closeButton>
        <Modal.Title>Propriedades do MDF-e</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-2">
          <Col xs={6}>
            <strong>Número MDF-e:</strong> {props.mdfe?.numeroMDFe}
          </Col>
          <Col xs={6}>
            <strong>Série:</strong> {props.mdfe?.serie}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col xs={6}>
            <strong>Placa Tração:</strong> {props.mdfe?.placaVeiculoTracao}
          </Col>
          <Col xs={6}>
            <strong>Percurso:</strong> {props.mdfe?.ufInicio} ➔ {props.mdfe?.ufFim}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col xs={6}>
            <strong>Docs Vinculados:</strong> {docsVinculadosTexto}
          </Col>
          <Col xs={6}>
            <strong>Valor Carga:</strong> R$ {valorCargaFormatado}
          </Col>
        </Row>

        <hr className="my-2" />
        <Row className="mb-1">
          <Col xs={12}>
            <strong>Status Envio:</strong> {codigoStatusEnvio} - {descricaoStatusEnvio}
          </Col>
        </Row>
        {props.mdfe?.autorizacao?.codigoStatusResposta && (
          <Row className="mb-1">
            <Col xs={12}>
              <strong>Retorno SEFAZ:</strong>{" "}
              {props.mdfe.autorizacao.codigoStatusResposta}
              {props.mdfe.autorizacao.descricaoMotivoResposta
                ? ` - ${props.mdfe.autorizacao.descricaoMotivoResposta}`
                : ""}
            </Col>
          </Row>
        )}
        {props.mdfe?.autorizacao?.chaveAcesso && (
          <Row className="mb-1">
            <Col xs={12} className="text-truncate">
              <small className="text-muted">
                Chave: {props.mdfe.autorizacao.chaveAcesso}
              </small>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        {isAutorizado ? (
          <>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onEncerrarHandler}
            >
              Encerrar
            </Button>
            <DropdownButton
              variant="outline-primary"
              title="DAMDFE"
              id="dropdown-damdfe"
              className="messagebox-btn-cancel"
            >
              <Dropdown.Item onClick={onPrintHandler}>
                Imprimir agora
              </Dropdown.Item>
              <Dropdown.Item onClick={onShareDamdfeHandler}>
                Compartilhar
              </Dropdown.Item>
              <Dropdown.Item onClick={onDownloadDamdfeHandler}>
                Baixar PDF
              </Dropdown.Item>
            </DropdownButton>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onDownloadXmlHandler}
            >
              Baixar XML
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onDuplicateHandler}
            >
              Duplicar
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onEventHandler}
            >
              Eventos
            </Button>
          </>
        ) : isCanceladoOuEncerrado ? (
          <>
            <DropdownButton
              variant="outline-primary"
              title="DAMDFE"
              id="dropdown-damdfe-encerrado"
              className="messagebox-btn-cancel"
            >
              <Dropdown.Item onClick={onPrintHandler}>
                Imprimir agora
              </Dropdown.Item>
              <Dropdown.Item onClick={onDownloadDamdfeHandler}>
                Baixar PDF
              </Dropdown.Item>
            </DropdownButton>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onDownloadXmlHandler}
            >
              Baixar XML
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onDuplicateHandler}
            >
              Duplicar
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onEventHandler}
            >
              Eventos
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="outline-danger"
              className="messagebox-btn-cancel"
              onClick={onDeleteHandler}
            >
              Excluir
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onFetchStatusHandler}
            >
              Consultar Situação
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onSendHandler}
            >
              Enviar
            </Button>
            <Button
              variant="outline-info"
              className="messagebox-btn-cancel"
              onClick={onEditHandler}
            >
              Alterar
            </Button>
          </>
        )}
        {props.mdfe?.id ? (
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onVisualizarHandler}
          >
            Visualizar
          </Button>
        ) : null}
        <Button
          variant="outline-secondary"
          className="messagebox-btn-cancel"
          onClick={onReturnHandler}
        >
          Sair
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MDFeModalPropriedadesView;
